var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendmssgside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6H5.00004C4.4696 6 3.9609 6.21071 3.58582 6.58579C3.21075 6.96086 3.00004 7.46957 3.00004 8V28C2.99773 28.3814 3.10562 28.7553 3.31074 29.0768C3.51585 29.3984 3.80947 29.6538 4.15629 29.8125C4.42057 29.9356 4.7085 29.9995 5.00004 30C5.46954 29.9989 5.92347 29.8315 6.28129 29.5275L6.29254 29.5187L10.375 26H27C27.5305 26 28.0392 25.7893 28.4142 25.4142C28.7893 25.0391 29 24.5304 29 24V8C29 7.46957 28.7893 6.96086 28.4142 6.58579C28.0392 6.21071 27.5305 6 27 6ZM20 19H12C11.7348 19 11.4805 18.8946 11.2929 18.7071C11.1054 18.5196 11 18.2652 11 18C11 17.7348 11.1054 17.4804 11.2929 17.2929C11.4805 17.1054 11.7348 17 12 17H20C20.2653 17 20.5196 17.1054 20.7071 17.2929C20.8947 17.4804 21 17.7348 21 18C21 18.2652 20.8947 18.5196 20.7071 18.7071C20.5196 18.8946 20.2653 19 20 19ZM20 15H12C11.7348 15 11.4805 14.8946 11.2929 14.7071C11.1054 14.5196 11 14.2652 11 14C11 13.7348 11.1054 13.4804 11.2929 13.2929C11.4805 13.1054 11.7348 13 12 13H20C20.2653 13 20.5196 13.1054 20.7071 13.2929C20.8947 13.4804 21 13.7348 21 14C21 14.2652 20.8947 14.5196 20.7071 14.7071C20.5196 14.8946 20.2653 15 20 15Z",
    fill: "#00308F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmssgside);
export default __webpack_public_path__ + "static/media/sendmssgside.2f597ee300acf45a1012e42d230521d2.svg";
export { ForwardRef as ReactComponent };